export enum Templates {
    TEMP1 = "template1", TEMP2 = "template2", TEMP3 = "template3", TEMP4 = "template4"
}